/**
 * Palmistry copy shared by the API and the coach app.
 *
 * The reading itself is written by the model from a photograph the member
 * takes; nothing about that photograph, or the reading, is ever stored. The
 * screen says so, which is the whole reason this constant lives here rather
 * than in one of them.
 */

export const COACHING_PALMISTRY_DISCLAIMER =
  'Palmistry is offered as a traditional reflective framework, not as a prediction and never as a statement about your health or your lifespan. Your photo is read once and is not saved: it is not stored on our servers and neither is this reading.';

/** What the member is told before they take the picture. */
export const COACHING_PALMISTRY_TIPS: readonly string[] = [
  'Use your dominant hand, palm open and flat.',
  'Good, even light. Daylight near a window is ideal; a hard flash flattens the lines.',
  'Fill the frame with the whole hand, from wrist to fingertips.',
  'Hold steady and let the camera focus before you take it.',
];
